import { RECEIVE_PICKUP_DATE } from '../actions/actionTypes';
import { Moment } from 'moment';
import MomentUtils from '@date-io/moment';

const initialState: Moment = new MomentUtils().date();

export default function pickupDateReducer(state: Moment = initialState, action: any) {

  switch (action.type) {

    case RECEIVE_PICKUP_DATE:
      return action.data;
    default:
      return state;
  }
};